import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class AvailableModels extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateModels);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateModels);
  }

  /**
   * Refreshes the "Lieferbare Modelle" list for the newly selected variant,
   * including appearing/disappearing entirely depending on whether that
   * variant has any data.
   *
   * Fetches its own copy of the page (keyed on the newly selected variant id)
   * instead of reusing the shared `event.detail.data.html` fetched by the core
   * variant picker, so a `?view=...` template-preview override on the current
   * URL is preserved - the core picker's own fetch always resolves the bare
   * product URL, which would use the product's saved default template.
   * @param {CustomEvent} event - The variant update event.
   */
  updateModels = async (event) => {
    if (event.detail.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const variantId = event.detail.resource?.id;
    if (!variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);

    let html;
    try {
      const response = await fetch(url.toString());
      if (!response.ok) return;
      html = new DOMParser().parseFromString(await response.text(), 'text/html');
    } catch (error) {
      return;
    }

    const newEl = html.querySelector('available-models');
    if (!newEl) return;

    morph(this, newEl, { childrenOnly: true });
  };
}

if (!customElements.get('available-models')) {
  customElements.define('available-models', AvailableModels);
}
